import React from 'react';
import PropTypes from 'prop-types';
import { Button, SvgIcon, Tooltip } from '@mui/material';
import { RadioButtonUnchecked as RadioButtonUncheckedIcon } from '@mui/icons-material';
import { Info as InfoIcon } from '@mui/icons-material';
import CheckCircleIcon from '../../../../../icons/check-circle.svg?react';
import './PlanInput.scss';

export default function PlanInput(props) {

    return (
        <Button
            variant={props.value ? 'outlined' : 'contained'}
            className={`shadow plan-card-input d-flex ${props.value ? `'active button-active-border` : 'inactive'} ${props.mobileWide ? 'wide-sm' : ''}`}
            onClick={props.onClick}
            aria-pressed={props.value}
            aria-labelledby={props.title}
        >
            <span className='plan-btn-span w-100'>
                <SvgIcon fontSize="large" color="primary" component={props.icon} className={props.infoText ? 'icons me-0 user-icon' : 'icons user-icon'} />
                {props.infoText && (
                    <Tooltip title={props.infoText} className="float-end m-0">
                        <InfoIcon color="action"></InfoIcon>
                    </Tooltip>
                )}
                <div className="text">
                    <h1 className="title">{props.title}</h1>
                    {props.subtitle && <p className="subtitle">{props.subtitle}</p>}
                </div>
                {props.amount && (<span className='amount primary-color' ><sup>$</sup> <span className="amount-value"><b>{props.amount}</b>/{props.unit}</span></span>)}
                {props.value ? (
                    <SvgIcon component={CheckCircleIcon} color="primary" name={props.productName} className="check check-icon" />
                ) : (
                    <SvgIcon component={RadioButtonUncheckedIcon} color="disabled" className="unCheck check-icon" />
                )}
            </span>
        </Button>
    );
}

PlanInput.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    mobileWide: PropTypes.bool,
};
